export default class LoginResult {
    constructor({ returnUrl, loginResultAction, secondaryEmail, userId, rememberMe }) {
        this.returnUrl = returnUrl;
        this.LoginResultAction = loginResultAction;
        this.SecondaryEmail = secondaryEmail;
        this.UserId = userId;
        this.RememberMe = rememberMe;
    }

    returnUrl: string;
    LoginResultAction: string;
    SecondaryEmail: string;
    UserId: string;
    RememberMe: boolean;
}